/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecutionFilter extends models.AwsSsmBaseDocumentFilter {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmExecutionFilter");
    }

    getFixupPrototypeFunction() { return AwsSsmExecutionFilter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecutionFilter>): AwsSsmExecutionFilter {
        let obj = Object.assign(new AwsSsmExecutionFilter(), model);
        AwsSsmExecutionFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecutionFilter>): AwsSsmExecutionFilter {
        if (!model) return null;
        return AwsSsmExecutionFilter.newInstance(<AwsSsmExecutionFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecutionFilter) {
        if (!obj) return;

        models.AwsSsmExecutionFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecutionFilter): boolean {
        if (models.AwsSsmBaseDocumentFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmExecutionFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.AwsSsmExecutionQueryFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Document executed by
     */
    executed_by: Array<string>;

    /**
     * Name of the Automation/Command document
     */
    document_names: Array<string>;

    /**
     * Query filters for the execution
     */
    filters: models.AwsSsmExecutionQueryFilters;

}
